<template>
    <BModal
      :model-value="modal"
      scrollable
      centered
      title="Room Category"
      hide-footer
      @update:modelValue="updateModal"
    >
      <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
          <h5 class="">Room Category</h5>
        </div>
        <BButton variant="link" class="close" @click="updateModal(false)">
          <i class="ion ion-android-close"></i>
        </BButton>
      </template>
  
      <BForm @submit.prevent="handleAction">
        <!-- Nama kategori -->
        <b-form-group label="Room Category Name">
          <b-form-input
            v-model="roomCategoryForm.name"
            type="text"
            placeholder="Enter category name"
            required
          />
        </b-form-group>
  

        <!-- Harga per Source Type -->
        <b-form-group label="Prices">
          <b-table
            bordered
            small
            :items="roomCategoryForm.prices"
            :fields="priceFields"
          >
            <template #cell(source_type)="data">
              <!-- tampilkan label rapi -->
              {{ formatSourceLabel(data.item.source_type) }}
            </template>
  
            <template #cell(low)="data">
              <b-form-input
                type="number"
                v-model.number="data.item.low"
                min="0"
              />
            </template>
  
            <template #cell(high)="data">
              <b-form-input
                type="number"
                v-model.number="data.item.high"
                min="0"
              />
            </template>
          </b-table>
        </b-form-group>
  
        <!-- Warna -->
        <b-form-group label="Color">
          <b-form-input type="color" v-model="roomCategoryForm.color" />
        </b-form-group>
  
        <!-- Deskripsi -->
        <b-form-group label="Description">
          <b-form-textarea
            v-model="roomCategoryForm.description"
            placeholder="Enter description"
          />
        </b-form-group>
  
      </BForm>

        <!-- Tombol (juga ada footer) -->
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{
                roomCategoryData && roomCategoryData.uuid ? "Update" : "Save"
                }}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
    <!-- <ToastResponse
      v-model="modalResponse.toast"
      :text="modalResponse.text"
      :success="modalResponse.success"
    ></ToastResponse> -->

  </template>
  
  <script>
  import {
      BModal,
      BFormInput,
      BButton,
      BFormTextarea,
      BForm,
      BTable,
      BFormGroup,
    } from "bootstrap-vue-next";
  import {ref, inject, watch } from "vue";
  //import ToastResponse from "@/components/ToastResponse.vue";
  
  export default {
    components: {
      BModal,
      BFormInput,
      BButton,
      BFormTextarea,
      BForm,
      BTable,
      BFormGroup,
      //ToastResponse
    },
    props: {
      modal: Boolean,
      roomCategoryData: Object,
    },
    emits: ["update:modal", "addOrUpdate"],
    setup(props, { emit }) {
      const repositories = inject("repositories");
      const roomCategoryRepository = repositories ? repositories.roomCategory : null;

      // const modalResponse = ref({
      //   toast: false,
      //   text: "",
      //   success: false,
      // });
  
      const defaultRoomCategoryForm = {
        uuid: null,
        name: "",
        color: "#000000",
        description: "",
        prices: [
        { source_type: "direct_booking", low: 0, high: 0 },
        { source_type: "walk_in", low: 0, high: 0 },
        { source_type: "booking_online", low: 0, high: 0 },
        { source_type: "agent", low: 0, high: 0 },
        ],
      };

      // const resetForm = () => {
      //   roomCategoryForm.value = {
      //     id: null,
      //     name: "",
      //     description: "",
      //     color: "",
      //     prices: [],
      //   };
      // };
  
      // Fields must match keys in prices objects
      const priceFields = [
        { key: "source_type", label: "Source Type" },
        { key: "low", label: "Low Season Price" },
        { key: "high", label: "High Season Price" },
    ];
  
      const roomCategoryForm = ref({ ...defaultRoomCategoryForm });
  
      const updateModal = (value) => {
        emit("update:modal", value);
      };

      const handleAction = () => {
        // decide create or update
        //return props.roomCategoryData && props.roomCategoryData.uuid ? update() : create();
        props.roomCategoryData?.uuid ? update() : create();
      };

      // const handleError = (e, defaultMessage) => {
      //   const errors = e.response?.data?.errors;
      //     return {
      //       success: false,
      //       text: errors ? Object.values(errors)[0][0] : defaultMessage,
      //       toast: true,
      //     };
      // };
  
      // Helper to ensure incoming prices array is normalized to the 4 fixed source types
      const SOURCE_TYPES = defaultRoomCategoryForm.prices.map((p) => p.source_type);
  
      function normalizePrices(incoming) {
        const map = {};

        if (Array.isArray(incoming)) {
            incoming.forEach((p) => {
            const st = p.source_type;
            if (!st) return;
            if (!map[st]) {
                map[st] = { source_type: st, low: 0, high: 0 };
            }
            if (p.season === "low") {
                map[st].low = Number(p.price) || 0;
            } else if (p.season === "high") {
                map[st].high = Number(p.price) || 0;
            }
            });
        }

        return SOURCE_TYPES.map(
            (st) => map[st] ?? { source_type: st, low: 0, high: 0 }
        );
    }

  
      function formatSourceLabel(st) {
        if (!st) return "";
        return st.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
      }
  
      // create/update actions
      const create = async () => {
        if (!roomCategoryRepository) {
          console.error("roomCategoryRepository not injected");
          return;
        }
        try {
          const payload = {
            name: roomCategoryForm.value.name,
            description: roomCategoryForm.value.description,
            color: roomCategoryForm.value.color,
            prices: roomCategoryForm.value.prices.flatMap((p) => [
            {
                source_type: p.source_type,
                season: "low",
                price: Number(p.low) || 0,
            },
            {
                source_type: p.source_type,
                season: "high",
                price: Number(p.high) || 0,
            },
            ]),
          };
          //console.log("👉 Payload create category:", JSON.stringify(roomCategoryForm.value, null, 2));
          console.log("👉 Payload dikirim:", payload);

          const res =await roomCategoryRepository.create(payload);
          console.log("✅ Response create:", res);

          // Object.assign(modalResponse.value, {
          //   success: true,
          //   text: res.data.message || "Category CREATED successfully!",
          //   toast: true,
          // });

          //resetForm();
          updateModal(false);
          roomCategoryForm.value = { ...defaultRoomCategoryForm };
          emit("addOrUpdate");
        } catch (err) {
            console.error("Error add new category:", err.response?.data || err.message);
            //showToast(false, err.response?.data?.message || "Failed to create category");
            //modalResponse.value = handleError(err, "Create new category FAILED!");
        }
      };
  
      const update = async () => {
        if (!roomCategoryRepository) {
          console.error("roomCategoryRepository not injected");
          return;
        }

        try {
          const payload = {
            name: roomCategoryForm.value.name,
            description: roomCategoryForm.value.description,
            color: roomCategoryForm.value.color,
            // prices: roomCategoryForm.value.prices.map((p) => ({
            //   source_type: p.source_type,
            //   // low_season_price: Number(p.low_season_price) || 0,
            //   // high_season_price: Number(p.high_season_price) || 0,
            //   season: p.season,
            //   price: Number(p.price) || 0,
            // })),
            prices: roomCategoryForm.value.prices.flatMap((p) => [
              { source_type: p.source_type, season: "low", price: Number(p.low) || 0 },
              { source_type: p.source_type, season: "high", price: Number(p.high) || 0 },
            ]),

          };

          const res = await roomCategoryRepository.update(payload, props.roomCategoryData.uuid);
          console.log("✅ Response update:", res);

          // modalResponse.value = {
          //   toast: true,
          //   text: res.data.message || "Category UPDATED successfully!",
          //   success: true,
          // };

          updateModal(false);
          roomCategoryForm.value = { ...defaultRoomCategoryForm };
          emit("addOrUpdate");
          
        } catch (err) {
          //modalResponse.value = handleError(err, "Update category FAILED!");
          console.error(err);
        }
      };
  
      // expose saveRoomCategory so the form's @submit has a valid handler
      const saveRoomCategory = () => {
        handleAction();
      };
  
      // Watch incoming props and normalize prices
      watch(
        () => props.roomCategoryData,
        (newData) => {
          if (newData) {
            // merge basic fields but always normalize prices to our 4 source types
            const merged = {
              ...defaultRoomCategoryForm,
              ...newData,
            };
            merged.prices = normalizePrices(newData.prices ?? merged.prices);
            roomCategoryForm.value = merged;
          } else {
            roomCategoryForm.value = { ...defaultRoomCategoryForm };
          }
        },
        { immediate: true }
      );
  
      return {
        roomCategoryForm,
        updateModal,
        handleAction,
        create,
        update,
        priceFields,
        saveRoomCategory,
        formatSourceLabel,
        //modalResponse,
        //resetForm,
      };
    },
  };
</script>
  